// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */
.signup-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    max-width: 500px;
    margin: 0 auto;
  }
  
  /* Title */
  .signup-title {
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 20px;
  }
  
  /* Form */
  .signup-form {
    width: 100%;
  }
  
  /* Row Layout */
  .signup-row {
    display: flex;
    gap: 10px;
    margin-bottom: 15px;
  }
  
  /* Input Group */
  .signup-input-group {
    display: flex;
    flex-direction: column;
    flex: 1 1;
  }
  
  /* Input Fields */
  .signup-input {
    padding: 10px;
    font-size: 1rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  /* Submit Button */
  .signup-submit-button {
    width: 100%;
    padding: 10px;
    font-size: 1rem;
    font-weight: bold;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 15px;
  }
  
  .signup-submit-button:hover {
    background-color: #0056b3;
  }
  
  /* Footer Text */
  .signup-footer-text {
    margin-top: 20px;
    font-size: 0.9rem;
  }
  
  /* Error Message */
  .signup-error-text {
    color: red;
    font-size: 0.9rem;
    margin-top: 10px;
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/Signup.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,cAAc;EAChB;;EAEA,UAAU;EACV;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA,SAAS;EACT;IACE,WAAW;EACb;;EAEA,eAAe;EACf;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA,gBAAgB;EAChB;IACE,aAAa;IACb,sBAAsB;IACtB,SAAO;EACT;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA,kBAAkB;EAClB;IACE,WAAW;IACX,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,gBAAgB;EAChB;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA,kBAAkB;EAClB;IACE,UAAU;IACV,iBAAiB;IACjB,gBAAgB;EAClB","sourcesContent":["/* Main Container */\n.signup-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 20px;\n    max-width: 500px;\n    margin: 0 auto;\n  }\n  \n  /* Title */\n  .signup-title {\n    font-size: 2rem;\n    font-weight: bold;\n    margin-bottom: 20px;\n  }\n  \n  /* Form */\n  .signup-form {\n    width: 100%;\n  }\n  \n  /* Row Layout */\n  .signup-row {\n    display: flex;\n    gap: 10px;\n    margin-bottom: 15px;\n  }\n  \n  /* Input Group */\n  .signup-input-group {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n  }\n  \n  /* Input Fields */\n  .signup-input {\n    padding: 10px;\n    font-size: 1rem;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n  }\n  \n  /* Submit Button */\n  .signup-submit-button {\n    width: 100%;\n    padding: 10px;\n    font-size: 1rem;\n    font-weight: bold;\n    color: #fff;\n    background-color: #007bff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-top: 15px;\n  }\n  \n  .signup-submit-button:hover {\n    background-color: #0056b3;\n  }\n  \n  /* Footer Text */\n  .signup-footer-text {\n    margin-top: 20px;\n    font-size: 0.9rem;\n  }\n  \n  /* Error Message */\n  .signup-error-text {\n    color: red;\n    font-size: 0.9rem;\n    margin-top: 10px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
